import React, { useState, useEffect ,useContext} from 'react'
import '../../styles/create_template.css';

import { Link,useParams } from 'react-router-dom'
import * as Constants from '../../constants';

import { ShareContext } from '../../context/ShareContext'
import BackLoader from '../../components/backloader';

import { useNavigate } from 'react-router-dom'

import DynamicIcon from '../../components/dynamicicon';
import TiptapEditor from '../../components/controls/tip_tap_editor';
import JisButton from '../../components/controls/jisButton';
import JisCheckbox from '../../components/controls/jisCheckbox';

function CreateTemplate() {
const navigate = useNavigate();
     const {  activePage, token, profile,frequentData,setIsExpired, setAlert} = useContext(ShareContext);
    const [openSuccess, setOpenSuccess] = useState(false)
    const {id} = useParams();
    const {type}=useParams();
    const [loading, setLoading] = useState(false);
    const tempUrl= `${Constants.apiUrl}/setup/templates/${id}/details`;
    const holderUrl= `${Constants.apiUrl}/setup/templateholders`;
    const navlink=type==0?'/templates/affidafits':'/templates/document';
    const [template, setTemplate]=useState({title:''});
    const [holders, setHolders]=useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [html, setHtml] =useState('');
    const [icopy, setICopy] =useState(-1);
    const [isInternal, setIsInternal] = useState(false);
   // const [alert, setAlert]=useState ({open:false,title:'', subtitle:''});

    const [upHolders, setUpHolders ] =useState([]); //this list is coming from all of them

    const pattern= /\[.+?\]/g
    const isClipboard= (window.isSecureContext && navigator.clipboard);


 

    useEffect(() => {
        
        if(id!=null){
            LoadTemplate();
        }
        LoadHolders();
    
  }, [id])
  

  const LoadTemplate=()=>{
    setIsLoading(true);
    fetch(tempUrl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
      })
        .then((resp) => resp.json())
        .then((data) => {
            setIsLoading(false);
            if(data.code==0){
                setTemplate(data.template);
             // setHtml(atob(data.template.html))  ;
setHtml(Constants.b64decode(data.template.html))  ;
              setHolders(data.holders);
            }
            
        })
        .catch(error => {
            console.error(error);
            setIsLoading(false);
        })
}

const onTapCopy =(index)=>{
    const ho=upHolders[index];

    // if (window.isSecureContext && navigator.clipboard) {
      navigator.clipboard
      .writeText(ho.holder)
      .then(() => {
       // setBttnText("COPIED");
        setICopy(index);
        setTimeout(function () {
          //setBttnText("COPY CODE");
          setICopy(-1);
        }, 3000);
      })
      .catch((err) => {

        console.log(err.message);
      });
    /* } else {
      
      try {
        document.execCommand(ho.placeHolder);
        setICopy(index);
        setTimeout(function () {
          //setBttnText("COPY CODE");
          setICopy(-1);
        }, 3000);
        console.log('just without https')
      } catch (err) {
        console.error('Unable to copy to clipboard', err);
      }
    } */
    

}

const onSaveTemplate =async()=>{
    //write the txt to pdf
   // setIsDialog(false)
    //this will save only item added

    try {
        const theurl=id==null? `${Constants.apiUrl}/setup/saveTemplate`:`${Constants.apiUrl}/setup/saveTemplate/${id}`;
        setIsLoading(true);
        var b4=Constants.b64encode(html); //btoa(html) ;
        //holdersid are the ids on the selected 
        //first get out all the Placeholder in the html text
        var holdersId=new Set();
        console.log('html content');
        console.log(html);
        var ttag= html.match(pattern);
        if (ttag!=null ){
          const tags = Array.from(html.match(pattern))
          console.log('all availble tags')
          console.log(tags);
          //second retrieve all its of the selected placeholder
          //save that on.
          

          for (let index = 0; index < tags.length; index++) {
              const did = tags[index];
              var cc= upHolders.filter((c) => c.holder ==did);
              if(cc.length>0){
                  holdersId.add(cc[0].id);
              }
              
          }
        }
        
        console.log('tmeplate object goin to server');
        console.log(template);
        var temp={template:{...template, html:b4,isCaseRelated: type=='document'?1:0 ,isInternal}, holdersId:Array.from(holdersId), title:template.title}
        console.log(temp);
    


        const resp = await fetch(theurl, {
          method: 'POST',
          body: JSON.stringify(temp),
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });
        
        const responseData = await resp.json();
        setIsLoading(false);
        console.log(responseData);
        if (responseData.code === 0 ) {
          //on this back
          setOpenSuccess(true)
          setAlert({open:true, title:`${id==null?'Create Template':'Update Template'} `, subtitle:`${id==null?'Create Template':'Update Template'} successful`})
          navigate(navlink)   ;
        }else {
            setAlert(  {icon:'warning',open:true,title:'Template', subtitle:responseData.status});
          
        }
      } catch (error) {
        setIsLoading(false);
        console.error(error);
       
      }
}

const LoadHolders=()=>{
    setIsLoading(true);
    fetch(holderUrl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
      })
        .then((resp) => resp.json())
        .then((data) => {
            setIsLoading(false);
            if(data.code==0){
               
                setUpHolders(data.holders);
            }
            
        })
        .catch(error => {
            console.error(error);
            setIsLoading(false);
        })
}




  return (
    <div className='dm-doc-create'>
      
        <div className="body">

            <div className="back" onClick={() => window.history.back()}>
                <Link><DynamicIcon iname="arrow_back"/>  Back</Link>
            </div>
            <div className="write-up-box">
                <div className="content-edit">
                    <div className="dashboard-view">
                        <h2>Template Editor</h2>
                        <div className="form-inp">
                            <label htmlFor="templateName">Title of Template</label>
                            <input type="text" placeholder='Enter Template Name' id='templateName' value={template.title} onChange={(e)=> setTemplate({...template,title:e.target.value}) } />
                        </div>
                        <div style={{  padding: '20px' }}>
                            <TiptapEditor initialContent={html} onChange={(content) => setHtml(content)} />
                        </div>
                        
                        
                        <div className="form-inp">
                            <label htmlFor="templateName">Description</label>
                            <input type="text" placeholder='Enter Description Note' id='templateNote' value={template.note} onChange={(e)=> setTemplate({...template,note:e.target.value}) } />
                        </div>
                        <JisCheckbox label="Check if this Template for Internal use only" value={isInternal} onChange={(e)=>setIsInternal(e)} />
                        <div className="sep-btns">
                            <Link><button className='black'>Back</button></Link>
                            <JisButton className='red' onClick={onSaveTemplate }>{id==null?'Create Template':'Update Template'} <DynamicIcon iname="arrow_forward" />  </JisButton>
                        </div>
                    </div>
                </div>
                <div className="copy-paste">
                    <div className="dashboard-view">
                        <h2>Copy And Paste Placeholder To Editor</h2>
                        
                        <div className="placeholders">
                           {
                                upHolders.map((ho, i) => { return (
                                    <div className="place-copy" key={i}>
                                <p>{ho.name}</p>
                               {isClipboard ? <div className="tap-copy" onClick={()=> onTapCopy(i)}>
                                    <p>{icopy==i?'COPIED':'Tap to Copy'} </p>
                                     <DynamicIcon iname="content_copy" />
                                </div>:<div className="manual-copy" >
                                    <p>{ho.holder} </p>
                                   
                                </div>} 

                            </div>
                                )})
                            } 
                            

                            <div className="back-to-create">
                                <Link to='/templates/placeholders'>
                                     <DynamicIcon iname="arrow_back"/>
                                    <p>Goto Placeholders Setup</p>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           {/* {openSuccess && <div className={ "success open" }>
                <div className="success-box">
                    <h2>{id==null?'Create Template':'Update Template'}</h2>
                    <p> {id==null?'Create Template':'Update Template'}  successful</p>
                    <Link to={navlink}><button className='red'>Continue</button></Link>
                </div>
            </div>}  */}
    
        </div>
        <BackLoader open={loading} />
    </div>
  )
}

export default CreateTemplate